import { AlertTriangle, Check } from "lucide-react";

interface Props {
  statoInvio: string | null | undefined;
}

const POSITIVI = ["invio in partenza", "in coda"];

// Banner mostrato dopo il caricamento dei moduli firmati: esito dell'hook auto-invio A2A
// ("invio in partenza" | "in coda, parte alle 09:00" | "non abilitato" | "non inviabile: <...>").
export function StatoInvioBanner({ statoInvio }: Props) {
  if (!statoInvio) return null;
  const positivo = POSITIVI.some((p) => statoInvio.startsWith(p));
  return (
    <p
      className={
        positivo
          ? "mb-4 text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2 flex items-start gap-2"
          : "mb-4 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 flex items-start gap-2"
      }
    >
      {positivo ? (
        <Check size={16} className="shrink-0 mt-0.5" />
      ) : (
        <AlertTriangle size={16} className="shrink-0 mt-0.5" />
      )}
      <span>Stato invio: {statoInvio}</span>
    </p>
  );
}
